/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { InviteUsersAndTeams, List, MemberRole, MemberRoleOrGuest, UserContentPermission } from "./data-contracts";

/**
 * No description
 * @tags space-users, space-teams
 * @name InviteToSpace
 * @summary Invite a user or a team to a space
 * @request POST:/spaces/{spaceId}/permissions
 * @secure
 */

// @ts-ignore
export const inviteToSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: InviteUsersAndTeams;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions",
  method: "post",
  streaming: false,
  tags: ["space-users", "space-teams"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-users
 * @name ListUserPermissionsInSpace
 * @summary List space user permissions
 * @request GET:/spaces/{spaceId}/permissions/users
 * @secure
 */

// @ts-ignore
export const listUserPermissionsInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/users",
  method: "get",
  streaming: false,
  tags: ["space-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-users
 * @name UpdateUserPermissionInSpace
 * @summary Update space user permissions
 * @request PATCH:/spaces/{spaceId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserPermissionInSpace: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["space-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-users
 * @name RemoveUserFromSpace
 * @summary Remove a space user
 * @request DELETE:/spaces/{spaceId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const removeUserFromSpace: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/permissions/users/{userId}",
  method: "delete",
  streaming: false,
  tags: ["space-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-users
 * @name ListPermissionsAggregateInSpace
 * @summary List all space users permissions
 * @request GET:/spaces/{spaceId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If defined, only members with this role will be returned. */
    role?: MemberRole;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["space-users"],
  criticalityLevel: "low",
  deprecated: false,
};
